import jsPDF from 'jspdf';

/**
 * Converts a canvas with multiple pages stacked vertically into a multi-page PDF
 * @param canvas - The canvas element containing the vertically stacked pages
 * @param originalPageCount - The number of pages in the original PDF
 * @returns A Blob representing the generated PDF
 */
export async function convertCanvasToPdf(
  canvas: HTMLCanvasElement,
  originalPageCount: number
): Promise<Blob> {
  // Calculate dimensions
  const pageHeight = canvas.height / originalPageCount;
  const pageWidth = canvas.width;
  
  // Create PDF with A4 dimensions (210mm x 297mm)
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  
  // Calculate scale to fit page width
  const scale = pdfWidth / pageWidth;
  const scaledPageHeight = pageHeight * scale;
  
  // Process each page
  for (let i = 0; i < originalPageCount; i++) {
    // For pages after the first one, add a new page
    if (i > 0) {
      pdf.addPage();
    }
    
    // Calculate source coordinates
    const sourceY = i * pageHeight;
    
    // Create temporary canvas for this page
    const pageCanvas = document.createElement('canvas');
    pageCanvas.width = pageWidth;
    pageCanvas.height = pageHeight;
    const pageCtx = pageCanvas.getContext('2d');
    
    if (pageCtx) {
      // Copy the page content to the temporary canvas
      pageCtx.drawImage(
        canvas,
        0, sourceY, pageWidth, pageHeight,
        0, 0, pageWidth, pageHeight
      );
      
      // Convert to data URL with quality setting for OCR clarity
      const imgData = pageCanvas.toDataURL('image/jpeg', 0.95);
      
      // Add image to PDF with proper scaling
      pdf.addImage(
        imgData,
        'JPEG',
        0, 0, pdfWidth, scaledPageHeight
      );
    }
  }
  
  // Return PDF as Blob
  return pdf.output('blob');
}